<template>
  <div class="bottom-center-fade">

  </div>
    <div class="bottom-center-container">
      <div v-if="Completed" class="text-container" style="margin-bottom: 0;">You explored 3 or more locations</div>
      <div v-else class="text-container">
        Visit 3 or more locations to win a prize
      </div>
      <a class="prize" href="https://askhubi.typeform.com/to/n9848pQq" v-if="Completed">Claim your Prize!</a>
      
      <div class="image-container">
        <img
          v-for="name in imageNames"
          :key="name"
          :src="getImagePath(name)"
          :class="{ active: isActive(name) }"
          alt="Image"
        />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "FooterBadges",
    props: {
      activeItems: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        imageNames: ['lantern', 'heron', 'beach', 'fish', 'wildlife', 'selfie', 'oak'],
      };
    },
    methods: {
      getImagePath(name) {
        return require('@/assets/' + name + '.png');
      },
      isActive(name) {
        return this.activeItems.includes(name);
      },
    },
    computed: {
      Completed() {
        if(this.activeItems == null){
          return false;
        }
        return this.activeItems.length > 2;
      }
    }

  };
  </script>
  
  <style scoped>


.bottom-center-fade {
    position: fixed;
    bottom: 0;
    z-index: 400;
    background: rgb(0,0,0);
    background: linear-gradient(180deg, rgba(0,0,0,0) 5%, rgba(0,0,0,0.4) 100%);
    height: 150px;
    width: 100%;
  }
  .bottom-center-container {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 320px;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    z-index: 500;
    font-family: Arial, Helvetica, sans-serif;

    box-shadow: 0 2px 13px 0 rgba(0,0,0,0.39);
  }
  
  .text-container {
    margin-bottom: 10px;
    text-align: center;
  }
  
  .image-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
  }
  
  .image-container img {
    width: calc(100% / 7 - 10px);
    aspect-ratio: 1;
    object-fit: cover;
    margin: 5px;
    opacity: 0.25;
    filter: grayscale(100%);
    border-radius: 50%;
  }
  
  .image-container img.active {
    opacity: 1;
    filter: grayscale(0%);
    animation: glowing 3s infinite;
    
    
  }

  .prize{
		color: rgba(0,100,163,1);
		font-weight: 600;
    font-size: 1.75rem;
    padding: 0.75rem;
		position: relative;
		overflow: hidden;
		border: none;
  }

  @keyframes glowing2 {
  0% {
    box-shadow: 0 0 0 0 rgba(241, 201, 119, 0.5);
  }
  50% {
    box-shadow: 0 0 5px 2px rgba(241, 201, 119, 0.8);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(241, 201, 119, 0.5);
  }
}

  @keyframes glowing {
  0% {
    box-shadow: 0 0 0 0 rgba(249, 229, 174, 0.0);
  }
  50% {
    box-shadow: 0 0 5px 2px rgba(249, 229, 174, 0.8);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(249, 229, 174, 0.0);
  }
}

/* .glow-image {
  animation: glowing 2s infinite;
} */
  </style>
  